import { contributeSeasonPassPayload, convertShardsToCreditsPayload } from "@/types/types.dashboard"

//@ desc        Get season pass information for the player
//@ route       POST
//@ access      Private (Requires session ticket)
export async function getSeasonPassInformation(sessionTicket: string) {
    try {
        const request = await fetch(
            `${
                process.env.NEXT_PUBLIC_ENV === "development"
                    ? process.env.NEXT_PUBLIC_DEV_API_URL
                    : process.env.NEXT_PUBLIC_PROD_API_URL
            }/api/v1/metalcoreprivate/mission-nfts`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ sessionTicket }),
            }
        )

        const response = await request.json()

        if (!request.ok) {
            throw new Error(`Error: ${request.status} ${request.statusText} - ${JSON.stringify(response)}`)
        }

        return response
    } catch (error) {
        console.warn("Error fetching missionable NFTs", error)
    }
}

export async function getTitleData(sessionTicket: string) {
    const url =
        process.env.NEXT_PUBLIC_ENV === "development"
            ? "https://9DEEB.playfabapi.com/Client/GetTitleData"
            : "https://318D8.playfabapi.com/Client/GetTitleData"
    const request = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Authorization": sessionTicket,
            "accept-encoding": "gzip",
        },
    })
    const response = await request.json()
    if (!request.ok) {
        return {
            success: false,
            message: `Error retrieving title data: ${JSON.stringify(
                response.errorMessage || response.errorDetails || response
            )}`,
        }
    }
    return {
        success: true,
        data: response,
    }
}

export async function contributeToSeasonPass(payload: contributeSeasonPassPayload) {
    try {
        const request = await fetch(
            `${
                process.env.NEXT_PUBLIC_ENV === "development"
                    ? process.env.NEXT_PUBLIC_DEV_API_URL
                    : process.env.NEXT_PUBLIC_PROD_API_URL
            }/api/v1/metalcoreprivate/account/season-pass`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            }
        )

        const response = await request.json()

        if (!request.ok) {
            throw new Error(`Error: ${request.status} ${request.statusText} - ${JSON.stringify(response)}`)
        }

        return response
    } catch (error) {
        console.error("Error contributing to season pass", error)
    }
}

export async function convertShardsToCredits(payload: convertShardsToCreditsPayload) {
    try {
        const request = await fetch(
            `${
                process.env.NEXT_PUBLIC_ENV === "development"
                    ? process.env.NEXT_PUBLIC_DEV_API_URL
                    : process.env.NEXT_PUBLIC_PROD_API_URL
            }/api/v1/metalcoreprivate/account/shards-to-credits`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            }
        )

        const response = await request.json()

        if (!request.ok) {
            throw new Error(`Error: ${request.status} ${request.statusText} - ${JSON.stringify(response)}`)
        }

        return response
    } catch (error) {
        console.error("Error converting shards to credits", error)
    }
}

export async function fetchLeaderboardByStatisticNameAroundPlayer(
    StatisticName: string,
    PlayFabId: string,
    SessionTicket: string,
    MaxResultsCount: number
) {
    const url =
        process.env.NEXT_PUBLIC_ENV === "development"
            ? `https://9DEEB.playfabapi.com/Client/GetLeaderboardAroundPlayer`
            : `https://318D8.playfabapi.com/Client/GetLeaderboardAroundPlayer`

    const request = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Authorization": SessionTicket,
            "accept-encoding": "gzip",
        },
        body: JSON.stringify({ StatisticName, PlayFabId, MaxResultsCount }),
    })

    const response = await request.json()

    if (!request.ok) {
        return {
            success: false,
            data: JSON.stringify(response),
        }
    }

    return {
        success: true,
        data: response,
    }
}

export async function fetchLeaderboardsByStatisticNameByNumber(
    StatisticName: string,
    SessionTicket: string,
    MaxResultsCount: number,
    StartPosition: number
) {
    const url =
        process.env.NEXT_PUBLIC_ENV === "development"
            ? `https://9DEEB.playfabapi.com/Client/GetLeaderboard`
            : `https://318D8.playfabapi.com/Client/GetLeaderboard`

    const request = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Authorization": SessionTicket,
            "accept-encoding": "gzip",
        },
        body: JSON.stringify({ StatisticName, MaxResultsCount, StartPosition }),
    })

    const data = await request.json()

    if (!request.ok) {
        return {
            success: false,
            data: JSON.stringify(data),
        }
    }

    return {
        success: true,
        data,
    }
}

export async function setPassportWalletToPlayFabAccount(playerId: string, address: string) {
    const url = `${
        process.env.NEXT_PUBLIC_ENV === "development"
            ? process.env.NEXT_PUBLIC_DEV_API_URL
            : process.env.NEXT_PUBLIC_PROD_API_URL
    }/api/v1/playfab/set-passport-wallet`

    const request = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ playerId, address }),
    })

    const response = await request.json()

    if (!request.ok) {
        return {
            success: false,
            data: JSON.stringify(response),
        }
    }

    return {
        success: true,
        response,
    }
}

export async function setGameShiftWalletToPlayFabAccount(
    email: string,
    wallet: string,
    sessionTicket: string,
    selectedWallet: string
) {
    const url = `${
        process.env.NEXT_PUBLIC_ENV === "development"
            ? process.env.NEXT_PUBLIC_DEV_API_URL
            : process.env.NEXT_PUBLIC_PROD_API_URL
    }/api/v1/playfab/link-solana-wallet`

    const request = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, wallet, sessionTicket, selectedWallet }),
    })

    const response = await request.json()

    return response
}
